import styled from 'styled-components';
import { colors } from '../../../constants/Colors';
import { units } from '../../../helpers/styles/units';
import { typography } from '../../../helpers/styles/typography';
import { FontWeight } from '../../../constants/Styles/fontWeight';
import { Button } from '../../../components/Button';

export const Block = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${units(4)};
  background-color: ${colors.grey70};
  padding: ${units(8)};
  margin-top: ${units(4)};
`;

export const Title = styled.div`
  font-weight: ${FontWeight.MEDIUM};
  ${typography(10)};
`;

export const Hint = styled.div`
  color: ${colors.grey20};
  ${typography(5)};
`;

export const Actions = styled.div`
  display: flex;
  gap: ${units(4)};
  align-items: center;
`;

export const ResolveButton = styled(Button)`
  width: fit-content;
`;

export const Section = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${units(2)};
`;

export const SectionTitle = styled.div`
  font-weight: ${FontWeight.MEDIUM};
  ${typography(5)};
`;

export const FoundItem = styled.div`
  padding: ${units(3)} ${units(4)};
  background-color: ${colors.white};
  border: 1px solid ${colors.grayscale60};
  ${typography(5)};
`;

export const NotFoundItem = styled.div`
  color: ${colors.red};
  ${typography(5)};
`;
